/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage } from 'sarsaparilla';

import AvailableLotteriesPage from '../src/containers/AvailableLotteriesPage';
import HowLotteriesWorkPage from '../src/containers/HowLotteriesWorkPage';

import routesArray from './routesArray';

const Components: Record<string, React.ComponentType<object>> = {
    AvailableLotteriesPage,
    HowLotteriesWorkPage,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
